import Heart from "../assets/person frame 1.png";
import Star from "../assets/person frame 2.png";
import Globe from "../assets/Frame (3).png";
import DollarSign from "../assets/arrow circle.png";

export default function ResultMatrix({ questions, answers }) {
  const collectAnswers = (category) =>
    questions
      .filter((q) => q.category === category)
      .map((q) => answers[q.id])
      .filter(Boolean)
      .join("; ");

  const love = collectAnswers("love");
  const goodAt = collectAnswers("goodAt");
  const worldNeeds = collectAnswers("worldNeeds");
  const paidFor = collectAnswers("paidFor");

  const isComplete = love && goodAt && worldNeeds && paidFor;

  const categories = [
    {
      title: "What You Love",
      content: love,
      icon: Heart,
      color: "bg-[#FFE5E1]",
      bgImage:'bg-[#FFB8B3]',
      description: "Your passions and interests",
    },
    {
      title: "What You Are Good At",
      content: goodAt,
      icon: Star,
      color: "bg-[#EDEAFF]",
       bgImage:'bg-[#CE93D8]',
      description: "Your skills and talents",
    },
    {
      title: "What The World Needs",
      content: worldNeeds,
      icon: Globe,
      color: "bg-[#E6F4E5]",
       bgImage:'bg-[#A5D6A7]',
      description: "Problems you can solve",
    },
    {
      title: "What You Can Be Paid For",
      content: paidFor,
      icon: DollarSign,
      color: "bg-[#E4F2FA]",
       bgImage:'bg-[#90CAF9]',
      description: "Your economic opportunities",
    },
  ];

  return (
    <div className="space-y-8 p-6">
      <div className="text-center">
        <h2 className="text-3xl font-bold text-gray-800 mb-2">Your IKIGAI Map</h2>
        <p className="text-gray-600">Discover the intersection of your purpose</p>
      </div>

      <div className="grid md:grid-cols-2 gap-6">
        {categories.map((category, index) => (
          <div
            key={index}
            className={`${category.color} rounded-lg shadow-md border border-gray-200 p-5 h-full`}
          >
            <div className="flex items-start gap-4 mb-4">
              <div className={`${category.bgImage} w-10 h-10 p-2 shadow flex justify-center items-center`} style={{borderRadius:'6px'}}>
                <img src={category.icon} alt="icon" className="w-6 h-6" />
              </div>
              <div>
                <h3 className="text-lg font-bold text-gray-800">{category.title}</h3>
                <p className="text-sm text-gray-600">{category.description}</p>
              </div>
            </div>
            <p className="text-gray-800">{category.content || "No responses yet"}</p>
          </div>
        ))}
      </div>

      {isComplete && (
        <div className="rounded-lg border border-pink-200 bg-[#FFEAF1] p-6 shadow-md">
          <h3 className="text-2xl font-semibold text-black-700 mb-4 flex items-center gap-2">
             <div className="bg-pink-500 text-white w-12 h-12 flex items-center justify-center rounded-md text-xl shadow-sm">
                🌸
              </div> Your IKIGAI
          </h3>
          <p className="text-pink-800 leading-relaxed">
            Your IKIGAI lies at the intersection of what you love ({love}), what you're good at
            ({goodAt}), what the world needs ({worldNeeds}), and what you can be paid for ({paidFor}).
            This unique combination represents your reason for being and your path to a fulfilling life.
          </p>
          <div className="mt-5 flex flex-wrap gap-3">
            <span className="bg-[#F9C5D5] text-pink-800 px-4 py-1 rounded-full text-sm font-medium">
              Purpose-driven
            </span>
            <span className="bg-[#C7E8F6] text-blue-800 px-4 py-1 rounded-full text-sm font-medium">
              Meaningful Work
            </span>
            <span className="bg-[#E8D6F7] text-purple-800 px-4 py-1 rounded-full text-sm font-medium">
              Sustainable Path
            </span>
          </div>
        </div>
      )}
    </div>
  );
}
